export const PARTNER_ONBOARD_REQUEST = "PARTNER_ONBOARD_REQUEST"
export const PARTNER_ONBOARD_SUCCESS = "PARTNER_ONBOARD_SUCCESS"
export const PARTNER_ONBOARD_FAILURE = "PARTNER_ONBOARD_FAILURE"
